import { useState } from "react";
import { useBlogStore } from "../store";
import { localizePost, type LocalizationInfo } from "../api";
import { Selector } from "./Selector";
import { Button } from "./Button";

interface LocalizationModalProps {
  isOpen: boolean;
  onClose: () => void;
  parentPost: any;
}

export function CreateLocalizationModal({ isOpen, onClose, parentPost }: LocalizationModalProps) {
  const { selectedBlog } = useBlogStore();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedLanguage || !selectedBlog) return;

    setIsCreating(true);
    try {
      const newPost = await localizePost({
        language: selectedLanguage as LocalizationInfo["language"],
        parentId: parentPost.parentId || parentPost.id
      });

      if (newPost.data?.id) {
        window.open(`/edit/${newPost.data?.id}`, "_blank");
      }

      onClose();
    } catch (error) {
      console.error("Failed to create localization:", error);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center'>
      <div
        className='absolute inset-0 bg-black/50 backdrop-blur-sm'
        onClick={onClose}
      />
      <div className='relative bg-white rounded-lg p-4 w-96 flex gap-6 flex-col shadow-xl'>
        <h2 className='text-lg font-semibold capitalize'>Post Localization</h2>
        <form
          onSubmit={handleSubmit}
          className='flex gap-3 flex-col'
        >
          <div className='relative pt-2'>
            <span className='text-[10px] z-10 uppercase font-semibold text-gray-500 absolute top-0 left-2 bg-white px-1'>Language</span>

            <Selector
              className='w-full border border-[#e0e0e0] rounded-md focus:outline-none focus:border-[#9d9d9d] cursor-pointer'
              value={selectedLanguage}
              onChange={(value) => setSelectedLanguage(value)}
              options={parentPost.availableLanguages || []}
            />
          </div>

          <Button
            type='submit'
            variant='successes'
            loading={isCreating}
            disabled={!selectedLanguage}
            className='self-end'
          >
            Create
          </Button>
        </form>
      </div>
    </div>
  );
}
